/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Mahesh        21/11/2020      3600: language translation issue
*********************************************************************************/
import HeartIcon from "assets/icons/heart.svg";
import CheckmarkIcon from "assets/icons/checkmark.svg";
import { Trans } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVirus } from '@fortawesome/free-solid-svg-icons'

export default ({
  src,
  alt,
  value,
  text,
  linkText,
  bgColor,
  direction,
  cashLess,
  goCareOption,
  altText,
  isCovidTestingAvailable
}) => (
  <div className="care-option">
    <div className="care-option-inner">
      <div className="care-option-header">
        {!direction || direction === "Other" ? null : (
          <div
            className={`care-option-result-type care-option-result-type--${direction.toLowerCase()}`}
          >
            <div className="inline mr-1 icon icon-color-white">
              {direction === "Top" ? <HeartIcon id={alt}/> : <CheckmarkIcon />}
            </div>
            {direction === "Top" ? (
              <Trans i18nKey="findcareoption.Careoptions.topcareoption">
                Top Care Option
              </Trans>
            ) : (
              <Trans i18nKey="findcareoption.Careoptions.goodcareoption">
                Good Care Option
              </Trans>
            )}
          </div>
        )}
      </div>
      <div
        className="care-option-image-container"
        style={{ backgroundColor: bgColor }}
      >
        <div
          className="care-option-image-inner"
          style={{ cursor: "pointer" }}
          
          onClick={() => 
            goCareOption({ alt, value })  
          }
        >
          <img src={src} alt={alt} />
        </div>
      </div>
      
     
      {/* <div className="care-option-header bottom">
        {!isCovidTestingAvailable ? null : (
          <div
            className={`care-option-result-type care-option-result-type-carousel`}
          >
            <div className="inline mr-1 icon icon-color-white">
            <FontAwesomeIcon  icon={faVirus} />
            </div>
            <Trans i18nKey="findcareoption.Careoptions.COVIDTestingAvailable">
              COVID Testing Available
              </Trans>
          </div>
        )}
      </div> */}
      <div className="care-option-content">
        <div className="care-option-margin">
          {altText}
          {!cashLess ? null : (
            <span className="care-option-badge-blue">
              <Trans i18nKey="findcareoption.Careoptions.Cashless">
                Cashless
              </Trans>
            </span>
          )}
          {!isCovidTestingAvailable ? null : (
            <span className="care-option-badge-blue">
              <Trans i18nKey="findcareoption.Careoptions.COVIDTestingAvailable">
              COVID Testing Available
              </Trans>
            </span>
          )}
        </div>
        <p className="care-option-text">{text}</p>
        <div className="text-right mx-2">
          <a
            className="text-caps text-smaller"
            onClick={() => 
              goCareOption({ alt, value })
            }
            onKeyDown={(e) =>{
              if(e.key === " " || e.key ==="Spacebar"){
                goCareOption({ alt, value })
              }
            }}
            href='#'
          >
            {linkText}
          </a>
        </div>
      </div>
    </div>
  </div>
);
